import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "index container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [_vm._v("Home")]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { to: { name: "inventoryReservationDashboard" } },
                    },
                    [_vm._v("Inventory Reservations")]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(VBreadcrumbsItem, { attrs: { active: "" } }, [
                    _vm._v("All Reservations"),
                  ]),
                ],
                1
              ),
              _c(
                VExpansionPanels,
                { staticClass: "mb-4", attrs: { flat: "" } },
                [
                  _c(
                    VExpansionPanel,
                    [
                      _c(VExpansionPanelHeader, [
                        _c(
                          "span",
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-filter")]
                            ),
                            _vm._v(" Filters"),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        VExpansionPanelContent,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      clearable: "",
                                      label: "Search",
                                      placeholder: "Product or document #",
                                      "append-icon": "mdi-magnify",
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.search.apply(null, arguments)
                                      },
                                      "click:clear": _vm.clearSearch,
                                      "click:append": _vm.search,
                                    },
                                    model: {
                                      value: _vm.searchTerms,
                                      callback: function ($$v) {
                                        _vm.searchTerms = $$v
                                      },
                                      expression: "searchTerms",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "6", md: "2" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      clearable: "",
                                      type: "number",
                                      label: "Worksheet ID",
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.search.apply(null, arguments)
                                      },
                                      "click:clear": _vm.search,
                                    },
                                    model: {
                                      value: _vm.filterWorksheetId,
                                      callback: function ($$v) {
                                        _vm.filterWorksheetId = _vm._n($$v)
                                      },
                                      expression: "filterWorksheetId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "6", md: "2" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      clearable: "",
                                      type: "number",
                                      label: "Inventory ID",
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.search.apply(null, arguments)
                                      },
                                      "click:clear": _vm.search,
                                    },
                                    model: {
                                      value: _vm.filterInventoryId,
                                      callback: function ($$v) {
                                        _vm.filterInventoryId = _vm._n($$v)
                                      },
                                      expression: "filterInventoryId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      clearable: "",
                                      label: "Worksheet Status",
                                      items: ["PENDING", "SUBMITTED"],
                                    },
                                    on: { change: _vm.search },
                                    model: {
                                      value: _vm.filterWorksheetStatus,
                                      callback: function ($$v) {
                                        _vm.filterWorksheetStatus = $$v
                                      },
                                      expression: "filterWorksheetStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "6", md: "1" } },
                                [
                                  _c(VSwitch, {
                                    staticClass: "mt-1",
                                    attrs: { label: "Stale", dense: "" },
                                    on: { change: _vm.search },
                                    model: {
                                      value: _vm.filterStaleOnly,
                                      callback: function ($$v) {
                                        _vm.filterStaleOnly = $$v
                                      },
                                      expression: "filterStaleOnly",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "6", md: "2" } },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { text: "", color: "grey" },
                                      on: { click: _vm.clearFilters },
                                    },
                                    [_vm._v("Clear")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.selected.length > 0
                ? _c(
                    VToolbar,
                    {
                      staticClass: "mb-2",
                      attrs: { flat: "", dense: "", color: "transparent" },
                    },
                    [
                      _c(
                        VChip,
                        {
                          staticClass: "mr-2",
                          attrs: { color: "primary", small: "" },
                        },
                        [_vm._v(_vm._s(_vm.selected.length) + " selected")]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: { small: "", color: "warning", outlined: "" },
                          on: { click: _vm.bulkRelease },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-lock-open-outline"),
                          ]),
                          _vm._v(" Release Selected "),
                        ],
                        1
                      ),
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { small: "", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.selected = []
                            },
                          },
                        },
                        [_vm._v("Clear Selection")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.inventoryReservationList,
                      "items-per-page": _vm.pagination.pageSize,
                      loading: !_vm.inventoryReservationProcessed,
                      "server-items-length": _vm.pagination.totalSize,
                      page: _vm.pagination.current,
                      "disable-pagination":
                        !_vm.inventoryReservationList ||
                        _vm.inventoryReservationList.length < 1,
                      "hide-default-header":
                        !_vm.inventoryReservationList ||
                        _vm.inventoryReservationList.length < 1,
                      "hide-default-footer":
                        !_vm.inventoryReservationList ||
                        _vm.inventoryReservationList.length < 1,
                      options: _vm.options,
                      "show-select": "",
                      "item-key": "id",
                      "item-class": _vm.rowClass,
                    },
                    on: {
                      "update:options": [
                        function ($event) {
                          _vm.options = $event
                        },
                        _vm.pageChanged,
                      ],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.processWorksheetId",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openWorksheet(
                                        item.processWorksheetId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.worksheetName) +
                                      " " +
                                      _vm._s(item.processWorksheetId) +
                                      " "
                                  ),
                                ]
                              ),
                              item.processName
                                ? _c("div", { staticClass: "text-caption" }, [
                                    _vm._v(_vm._s(item.processName)),
                                  ])
                                : _vm._e(),
                              item.worksheetStatus
                                ? _c(
                                    VChip,
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        "x-small": "",
                                        outlined: "",
                                        color:
                                          item.worksheetStatus === "PENDING"
                                            ? "orange"
                                            : "green",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.worksheetStatus) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "item.inventoryId",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openInventory(item.inventoryId)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.inventoryId))]
                              ),
                              item.inventoryUnitId
                                ? _c("span", { staticClass: "text-caption" }, [
                                    _vm._v(
                                      " / " + _vm._s(item.inventoryUnitCode)
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "item.createTime",
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatDateYear")(item.createTime)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.quantity",
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(item.quantity)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.age",
                          fn: function ({ item }) {
                            return [
                              _c(
                                VChip,
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: _vm.ageColor(item.createTime),
                                    dark: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.ageText(item.createTime)) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-1",
                                  attrs: { small: "", title: "View Inventory" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openInventory(item.inventoryId)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-information-outline ")]
                              ),
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-1",
                                  attrs: { small: "", title: "View Worksheet" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openWorksheet(
                                        item.processWorksheetId
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" mdi-file-document-outline ")]
                              ),
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    small: "",
                                    title: "Release",
                                    color: "warning",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.releaseSingle(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-lock-open-outline ")]
                              ),
                              _c(
                                VIcon,
                                {
                                  attrs: {
                                    small: "",
                                    title: "Delete",
                                    color: "error",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-delete ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2568511778
                    ),
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
      _c("inventory-lookup", {
        attrs: { activated: _vm.lookupInventory },
        on: {
          "update:activated": function ($event) {
            _vm.lookupInventory = $event
          },
        },
        model: {
          value: _vm.selectedInventory,
          callback: function ($$v) {
            _vm.selectedInventory = $$v
          },
          expression: "selectedInventory",
        },
      }),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          model: {
            value: _vm.worksheetDialog,
            callback: function ($$v) {
              _vm.worksheetDialog = $$v
            },
            expression: "worksheetDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-end" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.worksheetDialog = null
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c("worksheet-card", {
                    key: _vm.selectedWorksheet,
                    attrs: {
                      worksheet: _vm.selectedWorksheet,
                      showEditButtons: false,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }